import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ResearchJobPage from "./pages/ResearchJobPage";
import HistoryPage from "./pages/HistoryPage";
import FavoritesPage from "./pages/FavoritesPage";
import SettingsPage from "./pages/SettingsPage";
import SchedulesPage from "./pages/SchedulesPage";
import StoreLayout from "./store/StoreLayout";
import StorefrontHome from "./store/StorefrontHome";
import ProductDetail from "./store/ProductDetail";
import CheckoutSuccess from "./store/CheckoutSuccess";
import CheckoutCancel from "./store/CheckoutCancel";
import ShippingReturnsPage from "./store/ShippingReturnsPage";
import PrivacyPolicyPage from "./store/PrivacyPolicyPage";
import TermsPage from "./store/TermsPage";
import FAQPage from "./store/FAQPage";
import ContactPage from "./store/ContactPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import OrdersPage from "./pages/OrdersPage";
import { CartProvider } from "./store/CartContext";
import { StoreRegionProvider } from "./store/StoreRegionContext";

function App() {
  return (
    <div className="App">
      <StoreRegionProvider>
        <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* Public storefront */}
            <Route element={<StoreLayout />}>
              <Route path="/" element={<StorefrontHome />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/shipping-returns" element={<ShippingReturnsPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>

            {/* Admin / Research dashboard */}
            <Route path="/admin" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="research/:jobId" element={<ResearchJobPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="favorites" element={<FavoritesPage />} />
              <Route path="schedules" element={<SchedulesPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
      </StoreRegionProvider>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
